var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOpera(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7328 25.0176C8.9632 22.928 7.8176 19.8432 7.7408 16.3776C7.7408 16.368 7.7408 15.632 7.7408 15.6224C7.8176 12.1568 8.9632 9.072 10.7328 6.9824C13.0304 4.0032 16.4416 2.112 20.2496 2.112C22.592 2.112 24.7872 2.8288 26.6624 4.0736C23.8464 1.552 20.1344 0.016 16.0608 0C16.0416 0 16.0192 0 16 0C7.1648 0 0 7.1648 0 16C0 24.5824 6.7552 31.584 15.2384 31.9808C15.4912 31.9936 15.744 32 16 32C20.096 32 23.8336 30.4608 26.6624 27.9296C24.7872 29.1712 22.5952 29.888 20.2496 29.888C16.4416 29.888 13.0304 27.9968 10.7328 25.0176Z",
    fill: "url(#paint0_linear_101_10)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7327 6.98234C12.2015 5.24794 14.0959 4.20474 16.1695 4.20474C20.8287 4.20474 24.6015 9.48474 24.6015 15.9999C24.6015 22.5151 20.8255 27.7951 16.1695 27.7951C14.0991 27.7951 12.2015 26.7487 10.7327 25.0175C13.0303 27.9967 16.4415 29.8879 20.2495 29.8879C22.5919 29.8879 24.7871 29.1711 26.6623 27.9295C29.9391 24.9983 31.9999 20.7391 31.9999 15.9999C31.9999 11.2607 29.9391 7.00154 26.6623 4.07354C24.7871 2.82874 22.5951 2.11194 20.2495 2.11194C16.4415 2.11194 13.0303 4.00314 10.7327 6.98234Z",
    fill: "url(#paint1_linear_101_10)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_101_10",
    x1: 13.3319,
    y1: 0.521728,
    x2: 13.3319,
    y2: 31.5343,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FF1B2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4381,
    stopColor: "#FA1A2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5939,
    stopColor: "#ED1528"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7581,
    stopColor: "#D60E21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9272,
    stopColor: "#B70519"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A70014"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_101_10",
    x1: 21.3666,
    y1: 2.34956,
    x2: 21.3666,
    y2: 29.7786,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9C0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#FF4B4B"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpera);
export default __webpack_public_path__ + "static/media/Opera.e876a3a1ef6c176ce02ddfca21b622eb.svg";
export { ForwardRef as ReactComponent };